import React  from "react";
import { Row, Col, Form } from "react-bootstrap";
import getCurrencyDetails from "utils/getCurrencyDetails";
import jsDig from "utils/jsDig.js"

export default function CurrencySelector(props) {
  const currencies = [
    "USD",
    "EUR",
    "JPY",
    "GBP",
    "AUD",
    "CAD",
    "CHF",
    "CNY",
    "HKD",
    "NZD",
    "AED",
    "INR",
    "SGD",
    "KRW"
  ]
  const selectedCurrency = props.selectedCurrency ? props.selectedCurrency : currencies[0]

  return (
    <>
      <div className={`currency-dropdown currency-dropdown-${selectedCurrency}`}>
        <Form.Control
          className={`primary mb-2`}
          size="md"
          as="select"
          name={props.nameAttribute}
          value={props.selectedCurrency}
          onChange={(e) => props.setSelectedCurrency(e.target.value)}
          >
          {currencies.map((currency) => {
            const currencyDetails = getCurrencyDetails(currency)
            return (
              <option key={currency} value={currency}>
                {`${currencyDetails.symbol != "" ? `(${currencyDetails.symbol})` : ""} ${currency}`}
              </option>
            );
          })}
        </Form.Control>
      </div>
    </>
  );
}
